import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
    components: {
        m2Sidebar
      },
    data() {
        return {
            tableData: [],
            key: "",
            loading: {}
        };
    },
    methods: {
        getData: function () {
            this.$http.get(globalProvider.serviceUrl("er/g/refis"), {
                params: {
                    loading: true
                }
            }).then(data => {
                if (data.body.code === resultCode.Success) {
                    this.tableData = data.body.data;
                } else if (data.body.code == resultCode.NotSuccess) {
                    this.$alert(getErrorMessage(data.body.message));
                }
            });
        },
        handleCancel(index, row) {
            this.$confirm("此操作将取消当次预约, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                .then(() => {
                    this.$http
                        .post(globalProvider.serviceUrl("er/s/c"), {
                            o_id: row.id
                        })
                        .then(data => {
                            if (data.body.code === resultCode.Success) {
                                this.key = data.body.data;
                                this.loading = this.$loading({
                                    lock: true,
                                    text: "取消预约中"
                                });
                                this.getOrderState();
                            } else if (data.body.code == resultCode.NotSuccess) {
                                this.$alert(getErrorMessage(data.body.message));
                            }
                        });
                })
                .catch(() => {});
        },
        formatter: function (row, column, cellValue) {
            let list = cellValue.split("-").splice(0, 3);
            return list.join("-");
        },
        getOrderState: function () {
            this.$http
                .get(globalProvider.serviceUrl("e_reg/g/ps/{key}"), {
                    params: {
                        key: this.key
                    }
                })
                .then(data => {
                    if (data.body.data.status == "succeed") {
                        this.loading.close();
                        this.getData();
                    } else if (
                        data.body.data.status == "failed" ||
                        data.body.data.status == "exception"
                    ) {
                        this.loading.close();
                        this.$alert(data.body.data.remark, "提示", {
                            confirmButtonText: "确定"
                        });
                    } else {
                        setTimeout(this.getOrderState, 2000);
                    }
                });
        },
        formatter: function (row, column, cellValue) {
            let list = cellValue.split("-").splice(0, 3);
            return list.join("-");
        }
    },
    created: function () {
        this.getData();
        this.$store.commit("setHeaderState", "0");
    }
};